<template>
    <div :class="'img-' + size" class="custom-icon">
		<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg"><g stroke="none" stroke-width="4" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M33 39h90a5 5 0 015 5v56a5 5 0 01-5 5H33a5 5 0 01-5-5V44a5 5 0 015-5zM19.193 81H8a5 5 0 01-5-5V20a5 5 0 015-5h90a5 5 0 015 5v9.63" class="path" stroke="#0C2340"/><path d="M53 57a2 2 0 012 2v9a2 2 0 01-2 2H42a2 2 0 01-2-2v-9a2 2 0 012-2h11zm47.5 1a5.5 5.5 0 015.496 5.279l.004.221h0a5.5 5.5 0 11-5.5-5.5zm11 0a5.5 5.5 0 110 11 5.5 5.5 0 010-11zm-71 29.5h13m8 0h13m8 0h13m8 0h13" class="highlight" stroke="#00BBDC"/></g></svg>
    </div>
</template>

<script>
    export default {
        props: {
            size: {
                type: String,
                default: '4x'
            }
        }
    }
</script>